export const STAGE = process.env.REACT_APP_API_STAGE;

export let CONTACT_API_BASE;
export let SEND_PDF;
export let DOWNLOAD_PDF;

if (STAGE === "prod") {
  SEND_PDF =
    "https://qeyttz7572.execute-api.us-east-1.amazonaws.com/prod/send-pdf";
  DOWNLOAD_PDF =
    "https://qeyttz7572.execute-api.us-east-1.amazonaws.com/prod/pdf-download";

  CONTACT_API_BASE = "https://4cw19887lb.execute-api.us-east-1.amazonaws.com/prod";
} else if (STAGE === "stage") {
  SEND_PDF =
    "https://eneuil4lol.execute-api.us-east-1.amazonaws.com/stage/send-pdf";
  DOWNLOAD_PDF =
    "https://eneuil4lol.execute-api.us-east-1.amazonaws.com/stage/pdf-download";

  CONTACT_API_BASE = "https://8gy1n6xhik.execute-api.us-east-1.amazonaws.com/stage";
} else {
  SEND_PDF =
    "https://89pne16fje.execute-api.us-east-1.amazonaws.com/dev/send-pdf";
  DOWNLOAD_PDF =
    "https://89pne16fje.execute-api.us-east-1.amazonaws.com/dev/pdf-download";

  CONTACT_API_BASE = "https://ah0e7114zi.execute-api.us-east-1.amazonaws.com/dev";
}

export const CONTACT_OFFICER_ZIP = `${CONTACT_API_BASE}/contact/officer/zip`;
export const CONTACT_AGENT_ZIP = `${CONTACT_API_BASE}/contact/agent/zip`;
export const CONTACT_AGENT = `${CONTACT_API_BASE}/contact/agent`;
